/** Darbų planai UI tokens — Variant A refined (handoff 2026-05-02) */

export const WORK_PLANS_ACCENT = '#2563EB';

export type WorkPlansStatusKey =
  | 'laukia'
  | 'pradėta'
  | 'baigta'
  | 'atšaukta'
  | 'perduota'
  | 'grąžinta';

export type WorkPlansPriorityKey = 'low' | 'medium' | 'high' | 'extreme' | 'ultra';

export interface StatusToken {
  bg: string;
  text: string;
  border: string;
}

export interface PriorityToken {
  chipBg: string;
  chipText: string;
  stripe: string;
}

export const STATUS_TOKENS: Record<WorkPlansStatusKey, StatusToken> = {
  laukia: { bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE' },
  pradėta: { bg: '#FFF7ED', text: '#C2410C', border: '#FED7AA' },
  baigta: { bg: '#F0FDF4', text: '#15803D', border: '#BBF7D0' },
  atšaukta: { bg: '#F9FAFB', text: '#6B7280', border: '#E5E7EB' },
  perduota: { bg: '#FAF5FF', text: '#7C3AED', border: '#DDD6FE' },
  grąžinta: { bg: '#FEF2F2', text: '#DC2626', border: '#FECACA' },
};

export const PRIORITY_TOKENS: Record<WorkPlansPriorityKey, PriorityToken> = {
  low: { chipBg: '#F3F4F6', chipText: '#6B7280', stripe: '#9CA3AF' },
  medium: { chipBg: '#EFF6FF', chipText: '#2563EB', stripe: '#3B82F6' },
  high: { chipBg: '#FFFBEB', chipText: '#D97706', stripe: '#F59E0B' },
  extreme: { chipBg: '#FFF1F2', chipText: '#E11D48', stripe: '#F43F5E' },
  ultra: { chipBg: '#3B0764', chipText: '#F3E8FF', stripe: '#7C3ABE' },
};

export const FILTER_CHIP_INACTIVE = {
  bg: '#ffffff',
  text: '#6B7280',
  border: '#E5E7EB',
} as const;

export const FILTER_CLEAR_CHIP = {
  bg: '#FEF2F2',
  text: '#DC2626',
  border: '#FCA5A5',
} as const;

export function getStatusToken(status: string): StatusToken {
  return STATUS_TOKENS[status as WorkPlansStatusKey] ?? STATUS_TOKENS.laukia;
}

export function getPriorityToken(priority: string): PriorityToken {
  return PRIORITY_TOKENS[priority as WorkPlansPriorityKey] ?? PRIORITY_TOKENS.low;
}

/** Legacy solid colors for weekly/monthly mini-blocks (priority stripe) */
export function getPriorityStripeColor(priority: string): string {
  return getPriorityToken(priority).stripe;
}

/** Selected row highlight — primary 8% */
export const ROW_SELECTED_BG = 'rgba(37, 99, 235, 0.08)';
export const ROW_NEW_BG = '#FFFBEB';
export const ROW_HOVER_BG = '#F8FAFC';

export const CARD_REGULAR = {
  bg: '#ffffff',
  border: '1px solid #E8EDF5',
} as const;

export const CARD_PROJECT = {
  bg: '#F5F7FF',
  border: '1.5px solid #C7D2FE',
} as const;

export const PROJECT_BADGE_SX = {
  backgroundColor: '#EEF2FF',
  color: '#4338CA',
  border: '1px solid #C7D2FE',
  borderRadius: '4px',
  fontSize: '11px',
  fontWeight: 600,
  px: 1,
  py: 0.25,
} as const;

/** Lithuanian weekday letters Mon–Sun when weekStartsOn: 1 */
export const WEEKDAY_HEADERS_LT = ['Pr', 'An', 'Tr', 'Kt', 'Pn', 'Šš', 'Sk'] as const;
